export default __webpack_public_path__ + "static/font-73fd3a01234c9ea430e9af2d0b12a4d4.woff2";